var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":"is-small","type":"is-warning is-light","rounded":true,"icon-left":"broom","loading":_vm.loading},on:{"click":_vm.clearCache}},[_vm._v(" Clear server-side cache ")])}
var staticRenderFns = []

export { render, staticRenderFns }